import React from 'react';
import SectionTitle from './SectionTitle';

const ProgressSection = ({ assessment }) => {
  return (
    <div className="template-section">
      <SectionTitle title="Progress Photos" />
      {assessment?.progress_photos ? (
          <div className="photos-list">
            <div className="photos-list-block">
              <h5>Front</h5>
              {assessment?.progress_photos?.front ? (
                  <div className="uploaded-photo">
                    <img src={assessment?.progress_photos?.front} alt="front" />
                  </div>
                ) : 'No Front Photo uploaded!'
              }
            </div>

            <div className="photos-list-block">
              <h5>Side</h5>
              {assessment?.progress_photos?.side ? (
                  <div className="uploaded-photo">
                    <img src={assessment?.progress_photos?.side} alt="side" />
                  </div>
                ) : 'No Side Photo uploaded!'
              }
            </div>

            <div className="photos-list-block">
              <h5>Back</h5>
              {assessment?.progress_photos?.back ? (
                  <div className="uploaded-photo">
                    <img src={assessment?.progress_photos?.back} alt="back" />
                  </div>
                ) : 'No Back Photo uploaded!'
              }
            </div>
          </div>
        ) : <div className="centralize">No progress photes added</div>
      }
    </div>
  );
};

export default ProgressSection;
